import { render, staticRenderFns } from "./host.vue?vue&type=template&id=07eb81b4&"
import script from "./host.ts?vue&type=script&lang=ts&"
export * from "./host.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports